<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="120px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="获取日期">
            <el-date-picker
              v-model="queryForm.dateRange"
              @change="dateChange"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="用户编号"
          prop="UserName"
        />
        <el-table-column
          align="center"
          label="用户昵称"
          prop="NickName"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="finish_time"
          label="抽奖结果"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.is_used == -1">未中奖</span>
            <span v-if="scope.row.is_used == 0">未抽奖</span>
            <span v-if="scope.row.is_used == 1">{{ scope.row.Code }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="finish_time"
          label="抽奖时间"
        >
          <template slot-scope="scope">
            {{ transTime(scope.row.lottery_time) }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          align="center"
          prop="refund_time"
          label="使用状态"
        >
        </el-table-column> -->
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getVisitorLotteryListApi } from "@/api/radio";
import { transTime } from '@/utils/transTime'

export default {
  data() {
    return {
      transTime,
      businessList: [],
      queryForm: {
        page: 1,
        pageSize: 10,
        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        dateRange: [], // 时间段
      }, // 搜索条件表单
      dialogForm: {}, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
      start: '',
      end: '',
      activity_id: null
    };
  },
  created() {
    let param = JSON.parse(sessionStorage.getItem('resultlist'))
    console.log(222, param)
    this.activity_id = param.id
    this.fetchData()
  },
  mounted() {},

  methods: {
    dateChange(val) {
      if(val){
        const [start, end] = val
        this.start = start + ' 00:00:00'
        this.end = end + ' 23:59:59'
      } else {
        this.start = ''
        this.end = ''
      }
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      this.queryForm.page = 1;
      this.fetchData();
    },
    async fetchData() {
      let params = {
        start_time: this.start,
        end_time: this.end,
        id: this.activity_id,
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
      };
      console.log(params);
      await getVisitorLotteryListApi(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.data_list
            this.total = res.data.total_record
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    submitForm() {},
  },
};
</script>
<style lang="scss" scoped>
.el-pagination {
  text-align: center;
  margin-top: 10px;
}

</style>